export default __webpack_public_path__ + "static/media/Screenshot 2025-07-17 at 18.58.42.faf2020e.png";